import React, { useImperativeHandle } from "react";
import { useRequest, useUpdateEffect } from "ahooks";
import MultipleSelector from "@/components/MultipleSelector";
import { useGlobalState } from "@/GlobalProvider";
import { useTranslation } from "@/langs/useTranslation";
import { getAllTagsAPI } from "@/apis/getAllTagsAPI";

const TagList = React.forwardRef(
  (
    {
      disabled,
      name,
      value,
      onChange,
      clearable,
      expandCompanies,
      className,
      style
    },
    ref
  ) => {
    const { t } = useTranslation();
    const { currentCompanyId } = useGlobalState();
    const { data = { tags: [] }, run } = useRequest(() =>
      getAllTagsAPI(true, expandCompanies ? 1 : undefined)
    );

    useUpdateEffect(run, [currentCompanyId]);

    useImperativeHandle(ref, () => ({
      getOptions: () => data.tags
    }));

    return (
      <MultipleSelector
        placeholder={t({ defaultMessage: "选择标签" })}
        options={data.tags}
        clearable={clearable}
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
        className={className}
        style={{ width: 180, ...style }}
      />
    );
  }
);

export default TagList;
